export const GET_DATA_REQUEST = 'GET_DATA_REQUEST';
export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
export const GET_DATA_ERROR = 'GET_DATA_ERROR';
export const GET_DATA_PERCENTAGE_CHANGE = 'GET_DATA_PERCENTAGE_CHANGE';
export const GET_CRYPTO_PRICE = 'GET_CRYPTO_PRICE';
export const GET_CRYPTO_PREDICTION = 'GET_CRYPTO_PREDICTION';

// Action creators return a consistent "command" object.
export const getRequestData = () => ({
  type: GET_DATA_REQUEST
});
export const getSuccessData= (value, price_btc, price_eth, price_ltc, price_xrp, price_eos, price_bnb, prediction_btc, prediction_bnb, prediction_eth, prediction_xrp, prediction_ltc, prediction_eos, percentage_change, prediction_btc_1d, prediction_eth_1d, prediction_ltc_1d, prediction_xrp_1d, prediction_eos_1d, prediction_bnb_1d, prediction_doge, prediction_ada, prediction_link, price_doge, price_ada, price_link, prediction_doge_1d, prediction_ada_1d, prediction_link_1d) => {
  return {
    type: GET_DATA_SUCCESS,
    value, 
    price_btc, 
    price_eth, 
    price_ltc, 
    price_xrp, 
    price_eos, 
    price_bnb,
    price_doge, 
    price_ada, 
    price_link,
    prediction_btc, 
    prediction_eth, 
    prediction_ltc, 
    prediction_eos, 
    prediction_xrp, 
    prediction_bnb,
    prediction_doge, 
    prediction_ada, 
    prediction_link,  
    percentage_change, 
    prediction_btc_1d, 
    prediction_eth_1d, 
    prediction_xrp_1d, 
    prediction_ltc_1d, 
    prediction_eos_1d, 
    prediction_bnb_1d,
    prediction_doge_1d, 
    prediction_ada_1d, 
    prediction_link_1d
  };
};

export const getPercentageChange= ( percentage_change) => {

  return dispatch => {


  dispatch ({
    type: GET_DATA_PERCENTAGE_CHANGE,
    percentage_change, 

  });
  }
};


export const getCryptoPriceSuccess= ( crypto_price, price_btc, price_eth, price_ltc, price_xrp, price_eos, price_bnb,  price_doge, price_ada, price_link) => {

  return  {
    type: GET_CRYPTO_PRICE,
    
    crypto_price, 
    price_btc, 
    price_eth, 
    price_ltc, 
    price_xrp, 
    price_eos, 
    price_bnb,
    price_doge, 
    price_ada, 
    price_link,


  }
};


export const getCryptoPredictionSuccess= ( prediction_btc, prediction_eth, prediction_ltc, prediction_xrp, prediction_eos, prediction_bnb, prediction_doge, prediction_ada, prediction_link, prediction_btc_1d, prediction_eth_1d, prediction_ltc_1d, prediction_xrp_1d, prediction_eos_1d, prediction_bnb_1d, prediction_doge_1d, prediction_ada_1d, prediction_link_1d ) => {

  return  {
    type: GET_CRYPTO_PREDICTION,
    
    prediction_btc,
    prediction_eth,
    prediction_ltc,
    prediction_xrp,
    prediction_eos,
    prediction_bnb,
    prediction_doge,
    prediction_ada,
    prediction_link,
    prediction_btc_1d,
    prediction_eth_1d,
    prediction_ltc_1d,
    prediction_xrp_1d,
    prediction_eos_1d, 
    prediction_bnb_1d,
    prediction_doge_1d,
    prediction_ada_1d,
    prediction_link_1d


  }
};

export const getCryptoPrice = (crypto_price) => async dispatch => {

  console.log('crypto price',(crypto_price))

  console.log('crypto price', JSON.parse(JSON.stringify(crypto_price)))


  if ((crypto_price).length !== 0) {


      let price_btc = JSON.stringify((crypto_price).find(item => item.Symbol.class_name === "BTCUSDT"))
      let price_eth = JSON.stringify((crypto_price).find(item => item.Symbol.class_name === "ETHUSDT"))
      let price_ltc = JSON.stringify((crypto_price).find(item => item.Symbol.class_name === "LTCUSDT"))
      let price_xrp = JSON.stringify((crypto_price).find(item => item.Symbol.class_name === "XRPUSDT"))
      let price_eos = JSON.stringify((crypto_price).find(item => item.Symbol.class_name === "EOSUSDT"))
      let price_bnb = JSON.stringify((crypto_price).find(item => item.Symbol.class_name === "BNBUSDT"))

      let price_doge = JSON.stringify((crypto_price).find(item => item.Symbol.class_name === "DOGEUSDT"))
      let price_ada = JSON.stringify((crypto_price).find(item => item.Symbol.class_name === "ADAUSDT"))
      let price_link = JSON.stringify((crypto_price).find(item => item.Symbol.class_name === "LINKUSDT"))


      dispatch(getCryptoPriceSuccess(crypto_price, price_btc, price_eth, price_ltc, price_xrp, price_eos, price_bnb, price_doge, price_ada, price_link ));  
  }
}



export const getCryptoPrediction = (crypto_prediction) => async dispatch => {


  if (JSON.parse(crypto_prediction).length !== 0) {

    console.log(JSON.parse(crypto_prediction))

    let prediction_btc = (JSON.parse(crypto_prediction)[0])
    let prediction_eth =  (JSON.parse(crypto_prediction)[1])
    let prediction_ltc = (JSON.parse(crypto_prediction)[2])
    let prediction_xrp = (JSON.parse(crypto_prediction)[3])
    let prediction_eos = (JSON.parse(crypto_prediction)[4])
    let prediction_bnb = (JSON.parse(crypto_prediction)[5])

    let prediction_doge = (JSON.parse(crypto_prediction)[6])
    let prediction_ada = (JSON.parse(crypto_prediction)[7])
    let prediction_link = (JSON.parse(crypto_prediction)[8])


    let prediction_btc_1d = (JSON.parse(crypto_prediction)[9])
    let prediction_eth_1d = (JSON.parse(crypto_prediction)[10])
    let prediction_ltc_1d = (JSON.parse(crypto_prediction)[11])
    let prediction_xrp_1d = (JSON.parse(crypto_prediction)[12])
    let prediction_eos_1d = (JSON.parse(crypto_prediction)[13])
    let prediction_bnb_1d = (JSON.parse(crypto_prediction)[14])


    let prediction_doge_1d = (JSON.parse(crypto_prediction)[15])
    let prediction_ada_1d = (JSON.parse(crypto_prediction)[16])
    let prediction_link_1d = (JSON.parse(crypto_prediction)[17])

      dispatch(getCryptoPredictionSuccess(prediction_btc, prediction_eth, prediction_ltc, prediction_xrp, prediction_eos, prediction_bnb, prediction_doge, prediction_ada, prediction_link, prediction_btc_1d, prediction_eth_1d, prediction_ltc_1d, prediction_xrp_1d, prediction_eos_1d, prediction_bnb_1d, prediction_doge_1d, prediction_ada_1d, prediction_link_1d  ));  
  }
}



export const getFailureData = data => {
  return {
    type: GET_DATA_ERROR,
    data
  };
};
// This method has one required option which is the reference to
// socket being utilized.  That connection happens somewhere else.
// Assume we're connected when this function is called.
export const getData = options => async dispatch => {


  
    var data = options.socket




        if (JSON.parse(data.data).length !== 0) {
        let price_btc = JSON.stringify((JSON.parse(data.data)[0]).find(item => item.Symbol.class_name === "BTCUSDT"))
        let price_eth = JSON.stringify((JSON.parse(data.data)[0]).find(item => item.Symbol.class_name === "ETHUSDT"))
        let price_ltc = JSON.stringify((JSON.parse(data.data)[0]).find(item => item.Symbol.class_name === "LTCUSDT"))
        let price_xrp = JSON.stringify((JSON.parse(data.data)[0]).find(item => item.Symbol.class_name === "XRPUSDT"))
        let price_eos = JSON.stringify((JSON.parse(data.data)[0]).find(item => item.Symbol.class_name === "EOSUSDT"))
        let price_bnb = JSON.stringify((JSON.parse(data.data)[0]).find(item => item.Symbol.class_name === "BNBUSDT"))

        let price_doge = JSON.stringify((JSON.parse(data.data)[0]).find(item => item.Symbol.class_name === "DOGEUSDT"))
        let price_ada = JSON.stringify((JSON.parse(data.data)[0]).find(item => item.Symbol.class_name === "ADAUSDT"))
        let price_link = JSON.stringify((JSON.parse(data.data)[0]).find(item => item.Symbol.class_name === "LINKUSDT"))

        let value = (JSON.parse(data.data)[0])
        let prediction_btc = (JSON.parse(data.data)[1])
        let prediction_bnb =  (JSON.parse(data.data)[2])
        let prediction_eth = (JSON.parse(data.data)[3])
        let prediction_xrp = (JSON.parse(data.data)[4])
        let prediction_ltc = (JSON.parse(data.data)[5])
        let prediction_eos = (JSON.parse(data.data)[6])

        let prediction_doge = (JSON.parse(data.data)[7])
        let prediction_ada = (JSON.parse(data.data)[8])
        let prediction_link = (JSON.parse(data.data)[9])
  

        let percentage_change = (JSON.parse(data.data)[10])
        let prediction_btc_1d = (JSON.parse(data.data)[11])
        let prediction_eos_1d = (JSON.parse(data.data)[12])
        let prediction_eth_1d = (JSON.parse(data.data)[13])
        let prediction_bnb_1d = (JSON.parse(data.data)[14])
        let prediction_xrp_1d = (JSON.parse(data.data)[15])
        let prediction_ltc_1d = (JSON.parse(data.data)[16])


        let prediction_doge_1d = (JSON.parse(data.data)[17])
        let prediction_ada_1d = (JSON.parse(data.data)[18])
        let prediction_link_1d = (JSON.parse(data.data)[19])

      dispatch(getSuccessData(value, price_btc, price_eth, price_ltc, price_xrp, price_eos, price_bnb, prediction_btc, prediction_bnb, prediction_eth, prediction_xrp, prediction_ltc, prediction_eos, percentage_change, prediction_btc_1d, prediction_eth_1d, prediction_ltc_1d, prediction_xrp_1d, prediction_eos_1d, prediction_bnb_1d, prediction_doge, prediction_ada, prediction_link, price_doge, price_ada, price_link, prediction_doge_1d, prediction_ada_1d, prediction_link_1d ));  

        }


  // Notify our state that we're doing something asynchronous.     
  // Sanity, don't need to pass the socket itself down the wire.

try {
    // Emit the request to the back-end via the socket.
   } catch (err) {
    dispatch(getFailureData(err));
   }
};